/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Обработка ошибки</h2>
    <p className={styles.description}>
      HTTP-запрос не всегда выполняется без ошибок, поэтому пользователю обязательно нужно дать понять если что-то пошло
      не так. Для этого в состояние добавляем свойство хранения ошибки.{' '}
    </p>
    <p className={styles.description}>
      При использовании промисов, для обработки ошибок используется блок <code className={styles.code}>catch()</code>,
      если он выполнится значит произошла ошибка. Установку индикатора загрузки переносим в блок{' '}
      <code className={styles.code}>finally()</code>, чтобы не дублировать код, который будет выполнен в любом случае.
    </p>
    <CopyBlock
      text={`/* ... */

class App extends Component {
  state = {
    articles: [],
    isLoading: false,
    error: null,
  };

  componentDidMount() {
    this.setState({ isLoading: true });

    axios
      .get('https://hn.algolia.com/api/v1/search?query=react')
      .then(response => this.setState({ articles: response.data.hits }))
      .catch(error => this.setState({ error }))
      .finally(() => this.setState({ isLoading: false }));
  }

  /* ... */
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      Осталось дополнить метод <code className={styles.code}>render()</code>.
    </p>
    <CopyBlock
      text={`/* ... */
class App extends Component {
  /* ... */
  render() {
    const { articles, isLoading, error } = this.state;

    return (
      <Fragment>
        {error && <p>Whoops, something went wrong: {error.message}</p>}
        {isLoading && <p>Loading...</p>}
        {articles.length > 0 && <ArticleList articles={articles} />}
      </Fragment>
    );
  }
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
